module.exports = __webpack_public_path__ + "css/Ascot.3ee19fb7.css";